module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUdwTAAAAAAAAAAAAAAAAO/v79/f37Kysvn5+UtLS4GBgcnJyf///y2xseUAAAAMdFJOUwBNLUQV3cWW8WF3q2wJ09wAAAAJcEhZcwAAAEgAAABIAEbJaz4AAAC+SURBVCjPY2CAACdlQ2EjFQYUoCwIBkbIYoqCUCCEEHMWhAMRmBiTIBJQQNeMZACKQkFBA0yFUKUsgmjAASjIjC4ogKkbol8QA8DtFo1CdirUSJkzmUiOcoQJnihEeFURJnjm6EK4TQjBM8cmwgQNEYJnTkPYwiiCZ9qhgoLIgmcSIQ7FKohVO1aLsDoJq+OxehNrgGANOqyBjD06GNEFDXBFMdbEgJ5soCnMEEsCw54UkROtCf7kjT0joGUZAM+GXBvG/+/sAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/article/play.png
// module id = 787
// module chunks = 0